 
import axios, { AxiosResponse } from 'axios' 
import {ResponseHelper} from '../../../../setup/index'
import {API_URL} from '../../../../setup/helpers/apiUrl'
import AuthService from '../../auth/redux/AuthService' 
import {UserModel} from '../../auth/models/UserModel' 
import { Customer, CustomerResponse } from '../models/CustomerModels'


export const GET_CUSTOMER_URL = `${API_URL}/api/CallCenter/GetCustomerFromSqlSearch`
export const GET_CUSTOMER_DETAIL_URL = `${API_URL}/api/CallCenter/GetCustomerFromCdsQuery`


const usr:UserModel =  AuthService.GetCurrentUser() != null ? JSON.parse(AuthService.GetCurrentUser()) : null ;

export async  function GetCustomer(searchModel:any, firmaUnvanType:string){ 
    let resp;
    try{
       await axios.post<ResponseHelper>(GET_CUSTOMER_URL + "?firmaUnvanType="+ firmaUnvanType, searchModel, {headers:{"Authorization":"bearer " + usr.accessToken}})
        .then((response) =>{
            console.log("then =>", response);
            resp = response;  
        })
        .catch((err) => {
          console.log("thenCatch =>", err);
          if(err.response.status === 401){
            document.location.reload();
          }
        });
        return resp;
      } 
      catch(err){
        console.log("login error =>", err);
        console.log("catch resp =>", resp);
        return err;
      }
}

export async function GetCustomerDetail(customerModel:CustomerResponse){
    var resp;
    console.log("OrderSend");
    try{
        await axios.post<ResponseHelper>(GET_CUSTOMER_DETAIL_URL, customerModel,
        {headers:{"content-type":"application/json", "Authorization":"bearer " + usr.accessToken}})
        .then((response) =>{
          console.log("then =>", response);
          resp = response; 
        })
        .catch((err) => {
          console.log("thenCatch =>", err);
          if(err.response.status === 401){
            document.location.reload();
          }
        });
        console.log("Response => ", resp);
        return resp;
      } 
      catch(err){
        console.log("login error =>", err);
        console.log("catch resp =>", resp);
        return err;
      }
}

 